import { render, staticRenderFns } from "./ReceiptProgressBar.vue?vue&type=template&id=452af2b0&"
import script from "./ReceiptProgressBar.vue?vue&type=script&lang=js&"
export * from "./ReceiptProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports